import React from "react";
import "antd/dist/antd.css";
import { Table } from "antd";
import ReactDragListView from "react-drag-listview";
import './draggableTable.css'

class DraggableTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      columns: this.props.table.columns
    }
  }

  componentDidMount() {
    this.props.getColumns(this.state.columns)
    // console.log(this.state.columns)
    // console.log(this.props.table.data)
  }

  onDragEnd = (fromIndex, toIndex) => {
    const columnsCopy = this.state.columns.slice();
    const item = columnsCopy.splice(fromIndex, 1)[0];
    columnsCopy.splice(toIndex, 0, item);
    this.setState({ columns: columnsCopy });
    this.props.getColumns(columnsCopy)
  };

  onChange = (pagination, filters, sorter, extra) => {
    console.log('params', pagination, filters, sorter, extra);
  }

  render() {
    return (
      <ReactDragListView.DragColumn
        onDragEnd={this.onDragEnd}
        nodeSelector="th"
      >
        {/* <hr className='hr-draggable' /> */}
        <Table
          scroll={{ x: this.state.columns.length * 200, y: '70vh' }}
          columns={this.state.columns}
          dataSource={this.props.table.data}
          pagination={{
            position: 'bottom',
            defaultPageSize: 50
            // showSizeChanger: true,
            // pageSizeOptions: ["2", "4", "6"]
          }}
        />
      </ReactDragListView.DragColumn>
    );
  }
}

export default DraggableTable;
